import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import naive from 'naive-ui'
import { setupAuthInterceptor } from '@/interceptors/authInterceptor';
import './assets/theme.css';

const app = createApp(App)

app.use(naive).use(createPinia()).use(router)

// Tiene que ir antes de mount(): si algún componente lanza una petición
// nada más montarse (un onMounted pidiendo el feed, por ejemplo), esa
// primera petición necesita el interceptor ya enganchado.
setupAuthInterceptor()

app.mount('#app')
